import React, { useState } from "react";
import Categories from "../Categories/Categories";
import HeroSection from "../HeroSection/HeroSection";
import { homeObjOne } from "../InfoSection/Data";
import InfoSections from "../InfoSection/InfoSections";
import NavBar from "../NavBar/NavBar";
import SideBar from "../SideBar/SideBar";
import Footer from "../Footer/Footer";

import ImageSlider from "../ImageSlider/ImageSlider";
import { SliderData } from "../ImageSlider/SliderData";
import "./Home.css";
const Home = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toogle = () => {
        setIsOpen(!isOpen);
    };
    return (
        <>
            <SideBar isOpen={isOpen} toogle={toogle} />
            <NavBar toogle={toogle} />
            <HeroSection />
            <InfoSections {...homeObjOne} />
            <Categories />
            <ImageSlider slides={SliderData} />
            <div class="flex justify-center">
                <img
                    src="https://res.cloudinary.com/dsjsbp6qy/image/upload/v1675701456/Dshop/El_texto_del_p%C3%A1rrafo_1_owiu7h.gif"
                    width={500}
                    height={250}
                />
            </div>

            <iframe
                id="Direccion"
                className="googlemaps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.849860558665!2d-74.22811138527767!3d11.198742292035817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef45fcd9b3b2953%3A0xba3ccfa79c47d9b!2sFerreteria%20CPJ!5e0!3m2!1ses!2sco!4v1675735724328!5m2!1ses!2sco"
                title="map"
                width={600}
                height={350}
            ></iframe>
            <Footer />

            <div class="whatsapp-btn">
                <a href="https://wa.me/573202951380" target="_blank">
                    <img
                        id="Contacto"
                        src="https://cdn-icons-png.flaticon.com/512/1383/1383269.png"
                        alt="WhatsApp"
                        width={100}
                        height={100}
                    />
                </a>
            </div>
        </>
    );
};

export default Home;
